// extracted by mini-css-extract-plugin
module.exports = {"button_container":"Usuarios_button_container__GpL7f","button":"Usuarios_button__3FwOE","sort":"Usuarios_sort__373Fu","btn":"Usuarios_btn__2xt8d"};